import { createStore } from 'vuex'
import app from './modules/app'
import tenant from './modules/tenant'
import user from './modules/user'
import tagsView from './modules/tagsView'
import permission from './modules/permission'
import storage from './modules/storage'
import getters from './getters'

const store = createStore({
    modules: {
        app,
        user,
        permission,
        storage,
        tagsView,
        tenant,
    },
    getters
})

export default store
